import {useCallback, useEffect, useState} from 'react';
import { getUserClientCountersApi, getUserAccountitzCountersApi } from '../../api/userActiveCounter';
import { UserActiveCounterConverter } from '../../converters/UserActiveCounterConverter';
import { UserActiveCounter, WebAppType } from '../../types/userActiveCounter';
import { formatDate } from '../../utils/date';


const useDashboardController = () => {
    const today = new Date();
    const [counters, setCounters] = useState<UserActiveCounter[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [fromDate, setFromDate] = useState<Date>(new Date(today.getFullYear(), today.getMonth(), 1));
    const [toDate, setToDate] = useState<Date>(today);
    const [selectedWebApp, setSelectedWebApp] = useState<WebAppType>(WebAppType.ORGANITZ);

    const getUserClientCounters = useCallback((from: string, to: string) => {
        setLoading(true);

        const apiCall = selectedWebApp === WebAppType.ORGANITZ 
            ? getUserClientCountersApi(from, to)
            : getUserAccountitzCountersApi(from, to);

        apiCall
            .then(res =>  {
                if (res.error) return;
                setCounters(UserActiveCounterConverter.convertFromApiToUserActiveCounters(res.data));
            })
            .finally(() => setLoading(false));
    }, [selectedWebApp]);


    useEffect(() => {
        if (!loading) {
            getUserClientCounters(formatDate(fromDate), formatDate(toDate));
        }
    }, []);

    useEffect(() => {
        getUserClientCounters(formatDate(fromDate), formatDate(toDate));
    }, [selectedWebApp]);

    return {
        counters,
        loading,
        getUserClientCounters,
        fromDate,
        setFromDate,
        toDate,
        setToDate,
        selectedWebApp,
        setSelectedWebApp
    };
};

export default useDashboardController;
